import { OwnershipStatusIndicator } from '@internal/backstage-plugin-common-library-react';
import React from 'react';

import {
  IconLinkVerticalProps,
  InfoCardVariants,
} from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';

import { AboutCard } from '../Components/AboutCard';

export const SubscriptionAboutCard = (props: {
  variant?: InfoCardVariants;
}) => {
  const { entity } = useEntity();

  const ownershipStatus =
    entity.metadata.annotations?.['tomtom.com/ownership-status'];

  const ownershipStatusLink: IconLinkVerticalProps[] = ownershipStatus
    ? [
        {
          label:
            ownershipStatus === 'confirmed'
              ? 'Ownership confirmed'
              : 'Ownership not confirmed',
          icon: (
            <OwnershipStatusIndicator
              isConfirmed={ownershipStatus === 'confirmed'}
            />
          ),
          disabled: true,
        },
      ]
    : [];

  return (
    <AboutCard
      variant={props.variant || 'gridItem'}
      additionalSubHeaderLinks={ownershipStatusLink}
    />
  );
};
